<template>
    <base-alert type="danger" class="mb-4" v-if="update">
        <i class="fas fa-exclamation-triangle mr-3"></i> {{ $t('pwa.app-version-notice') }}
    </base-alert>
</template>

<script>
    export default {

        props: {
            remoteVersion: {
                type: Number,
                required: true
            }
        },

        data() {
            return {
                update: false,
            }
        },

        created() {
            this.getAbout()
        },

        watch: {
            update(val) {
                if (val) {
                    this.$emit("show")
                }
            }
        },

        methods: {

            getAbout() {
                axios.get('/astral/api/front/pwa/about').then(resp => {
                    if (resp.data.app_version !== undefined) {
                        this.update = (this.remoteVersion > resp.data.app_version)
                    }
                })
            },
        }
    }
</script>
